import { DashboardDataGridContained } from 'bd-web-components'
import { ItemTitle } from '../styles'
import { useState, useEffect } from 'react'
import { FlowButtonControl } from '../../../../components/FlowButtonControl'
import {
  CourtesyRequestInitialProps,
  DataConfirmationProps,
} from '../../../../utils/courtesy-request-utils'
import { FormikProps } from 'formik'

interface TicketSelectorComponentProps {
  handleButtonClick: () => void
  rollBack: () => void
  data: DataConfirmationProps
  useFormikProps: FormikProps<CourtesyRequestInitialProps>
}

export const Confirmation = ({
  data,
  rollBack,
  handleButtonClick,
  useFormikProps,
}: TicketSelectorComponentProps) => {
  const [confirmationData, setConfirmationData] = useState<any>({
    success: false,
  })

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setConfirmationData({
        success: true,
        user: data.user_data.dataAsArray,
        event: data.event_data,
        ticket: data.ticket_data,
      })
    }
  }, [data, useFormikProps])

  return (
    <div
      style={{
        marginTop: '-20px',
      }}
    >
      <ItemTitle>Dados do cliente</ItemTitle>
      {confirmationData.success && (
        <DashboardDataGridContained data={confirmationData.user} />
      )}
      <ItemTitle>Evento</ItemTitle>
      {confirmationData.success && (
        <DashboardDataGridContained data={confirmationData.event} />
      )}
      <ItemTitle>Ingresso</ItemTitle>
      {confirmationData.success && (
        <DashboardDataGridContained data={confirmationData.ticket} />
      )}
      <FlowButtonControl
        rollback={rollBack}
        flowControl={confirmationData.success}
        action={handleButtonClick}
      />
    </div>
  )
}
